module.exports = __webpack_public_path__ + "static/media/girl01.5193bd18.png";